import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logUser  } from '../actions/index';
import { BASE_PATH } from '../constants/Global';

   function Logout() {

    const dispatch = useDispatch();
    const history  = useHistory({forceRefresh:true});

    dispatch(logUser(0));
    //dispatch(logUsername(''));
    localStorage.removeItem('user');
    // localStorage.clear();
    history.push('/')

  return (
   <>
    <div></div>
   </>
  )
}

export default Logout
